<template>
    <div class="cascade_config definition_config">
      <Spin size="large" fix v-if="spinShow"> <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <div class="cascade_config_left fixed_table">
        <div class="fixed_search_input">
          <Select v-model="modularCode" placeholder="模块名称选择" title="模块名称"  @on-change="initSearch()">
            <Option v-for="(option, index) in modularList" :value="option.id" :key="index">{{option.name}}</Option>
          </Select>
          <Button type="primary" @click="initSearch">查询</Button>
        </div>
        <div class="table_head">
          <table>
            <tr>
              <th class="font_style_set" style="width:10%;">序号</th>
              <th class="font_style_set" style="width:40%;">所属模块</th>
              <th class="font_style_set" style="width:50%;">显示名称</th>
            </tr>
          </table>
        </div>
        <div style="border-bottom: 1px solid rgb(235, 238, 245);" class="footer_style">
          <table class="table_head_footer">
            <tr v-for="(item , index) in infoTableList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}" @click="getDicts(item.id,item.list)" title="双击选中">
              <td  style="width:10%;">{{index+1}}</td>
              <td  style="width:40%;">{{item.modularName}}</td>
              <td  style="width:50%;">
                <input :value="item.customName" class="custom_input_select" :id="index+'customName'+item.id" @change="saveCustomAttribute(index+'customName'+item.id,item.id,'customName')"/>
              </td>
            </tr>
          </table>
        </div>
        <div class="page_style">
          <Page :total="total" size="small"  :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
          <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
        </div>
      </div>
      <div class="cascade_config_right fixed_table">
        <div class="table_head">
          <table>
            <tr>
              <th class="font_style_set" style="width:40%;">级联级别</th>
              <th class="font_style_set" style="width:30%;">是否启用</th>
              <th v-if="roleList['3_9-1']" class="font_style_set" style="width:30%;border-right: 0px">操作</th>
            </tr>
          </table>
        </div>
        <div class="footer_style">
          <table class="table_head_footer">
            <tr v-for="(item , index) in cascadeList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}">
              <td  style="width:40%;">{{item.grade}}</td>
              <td style="width:30%;">
                <select   v-if="item.cascadeIsUse=='0'"  class="custom_input_select" :id="index+'customIsSearch'+item.id" @change="saveCascadeAttribute(index+'customIsSearch'+item.id,item.id,'cascadeIsUse',item.customId,item.cascadeLeave)">
                  <option value="0" selected="selected">否</option>
                  <option value="1">是</option>
                </select>
                <select   v-if="item.cascadeIsUse=='1'"  class="custom_input_select" :id="index+'customIsSearch'+item.id" @change="saveCascadeAttribute(index+'customIsSearch'+item.id,item.id,'cascadeIsUse',item.customId,item.cascadeLeave)">
                  <option value="0">否</option>
                  <option value="1" selected="selected">是</option>
                </select>
              </td>
              <td v-if="roleList['3_9-1']" class="template_table_btn" style="width:30%;">
                <span class="search_btn" @click="editCascade(item.customId,item.cascadeLeave)">编辑</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <cascadeConfigPop :showDataDictEdit="showDataDictEdit" :cascadeLeave="cascadeLeave" :dictCode="dictCode" :moduleId="modularCode" @closeDataDictPop="closeDataDictPop"></cascadeConfigPop>
    </div>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    import cascadeConfigPop from '@/components/systemSetup/CascadeConfigPop.vue'
    export default {
        name: "CascadeConfig",
        mixins:[publicFunClass],
        components:{
          cascadeConfigPop
        },
        props:{
          pageCode:String
        },
        data(){
          return{
            showPageCount:0,
            modularCode:'1',
            modularList:[{'id':'1','name':'客户管理'},{'id':'2','name':'工单管理'},{'id':'3','name':'服务管理'}],
            currentPage:1,
            spinShow:true,
            showDataDictEdit:false,
            dictCode:'',
            cascadeLeave:'1',
            speedChangePage: 1,
            pageSize:20,
            total:0,
            cascadeContent:[],
            pageSizeList:[10,20,30,40,50,100,200],
            cascadeList:[],
            infoTableList:[],
            roleList:JSON.parse(localStorage.getItem("roleList")),
            configInfo: JSON.parse(localStorage.getItem("configInfo")),
            sysSupportWorkOrder: JSON.parse(localStorage.getItem("sysSupportWorkOrder")),
          }
        },
       methods:{
         saveCustomAttribute:function(demoId,id,name){
           let value=document.getElementById(demoId).value;
           if(!value){
             this.$Message.error("显示名称不能为空");
             return false;
           }
           let param={
             id:id,
             journalType:"系统管理=>级联数据设置=>编辑自定义字段显示名称",
             menuId:"null"
           };
           param[name]=value;
           let that=this;
           this.$http.post("custom/update-field.json",param) .then(function (res) {
             let result=res.data.flag;
             if(result!="666"){
               that.$Modal.info({
                 title:'提示',
                 content:res.data.msg
               });
               return false;
             }
             that.$Message.info("已保存成功");
             that.initSearch();
           })
         },
         saveCascadeAttribute:function(demoId,id,name,customId,cascadeLeave){
           let value=document.getElementById(demoId).value;
           let param={
             id:id,
             moduleId:this.modularCode,//模块id
             customId:customId, //自定义字段id
             cascadeLeave:cascadeLeave,
             journalType:"系统管理=>级联数据设置=>编辑级联数据",
             menuId:"null"
           };
           param[name]=value;
           let that=this;
           this.$http.post("cascade/updateCascade.json",param) .then(function (res) {
             let result=res.data.flag;
             if(result!="666"){
               that.$Modal.info({
                 title:'提示',
                 content:res.data.msg
               });
               return false;
             }
             that.$Message.info("保存成功");
             that.initSearch();
           })
         },
         closeDataDictPop:function(){
           this.showDataDictEdit=false;
         },
         editCascade:function (dictCode,cascadeLeave) {
           this.dictCode=dictCode;
           this.cascadeLeave=cascadeLeave;
           this.showDataDictEdit=true;
         },
         initSearch:function () {
           let that=this;
           that.infoTableList=[];
           this.spinShow=true;
           let param={
             moduleId:this.modularCode,//模块id
             pageNum:this.currentPage,
             pageSize:this.pageSize,
             type:'cascade',
             journalType:"null",
             menuId:"null"
           };
           this.$http.post("custom/fields.json",param) .then(function (res) {
             let result=res.data.flag;
             that.spinShow = false;
             if(result!="666"){
               that.$Modal.info({
                 title:'提示',
                 content:res.data.msg
               });
               return false;
             }
             that.infoTableList=[];
             that.cascadeList=[];
             let contentList=res.data.obj.list.content;
             let modularName="客户管理";
             // if(that.modularCode=='2'){
             //   modularName="工单管理";
             // }
             if(that.modularCode=='3'){
               modularName="服务管理";
             }
             if(that.modularCode=='2'){
               modularName="工单管理";
             }
             for(let i=0;i<contentList.length;i++){
                let param={
                  modularName:modularName,
                  customName:contentList[i].customName,
                  grade:"一级级联",
                  id:contentList[i].id,
                  list:contentList[i].list
               };
               that.infoTableList.push(param);

             }
            //  打开页面默认加载第一个
             if(contentList.length>0){
               that.cascadeList = contentList[0].list;
             }
             that.total=res.data.obj.list.totalSize;
           })
         },
         getDicts(id,dataList){
           this.cascadeList = dataList;
           for(let i=0;i<this.infoTableList.length;i++){
             let tableId=this.infoTableList[i].id;
             document.getElementById(tableId).style.backgroundColor=""
           }
           document.getElementById(id).style.backgroundColor="#57a3f3"
         }
       },
       created() {
         this.initSearch();
         if("0" == this.sysSupportWorkOrder){
           this.modularList.splice(1, 1);
         }
       },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/CascadeConfig.vue